import React from "react"
import { AuthConsumer } from "../auth/authContext"

const check = (action, context) => {
  const permissions = context.rules
  // TODO: Do we even need this?
  // if (!permissions) {
  //   return false
  // }
  if ((permissions && permissions.includes(action)) || action === "*") {
    return true
  }

  return false
}

const Can = (props: any) => {
  return (
    <AuthConsumer>
      {context => (check(props.perform, context) ? props.yes() : props.no())}
    </AuthConsumer>
  )
}

Can.defaultProps = {
  yes: () => null,
  no: () => null,
}

export default Can
